// import axios from "axios";
// import api from "./api";

// const API_URL = "http://127.0.0.1:8000/api";

// export async function getHeroSlides() {
//     const response = await axios.get(
//         `${API_URL}/home/hero-sliders`
//     );

//     return response.data?.data ?? [];
// }

import api from "../utils/axios";

export async function getHomePage(){

    const { data } = await api.get("/home");

  //  console.log("Response:",data.data);
   console.log("HOME API RESPONSE:", data);

    return data.data;

}




// const homeService = {

//     async getHeroSlides() {
//         const response = await api.get("/home/hero-sliders");

//         return response.data?.data ?? [];
//     },

//     async getSpecialOffers(limit = 12) {
//         const response = await api.get("/home/special-offers", {
//             params: {
//                 limit,
//             },
//         });

//         return response.data?.data ?? [];
//     },
// };

// export default homeService;